import React,{useEffect} from "react";
import {BrowserRouter as Router,Routes,Route,Navigate,useLocation} from "react-router-dom";
import ContactPage from './views/ContactPage';
import {AuthProvider} from "./auth/AuthContext";
import {BrandingProvider} from "./branding/BrandingContext";
import RequireAuth from "./auth/RequireAuth";
import PrivacyPolicy from './views/PrivacyPolicy';
import TermsPage from './views/TermsPage';
import NotFoundPage from './views/NotFoundPage';
// Layouts
import Header from "./views/Header";
import Footer from "./views/Footer";
import DashboardLayout from "./views/layout/DashboardLayout";
import "./styles/DashboardFixes.css";
import "./styles/PublicPages.css";

// Public pages
import HomePage from "./views/HomePage";
import QuotePage from "./views/QuotePage";
import ServicesPage from "./views/ServicesPage";
import EmployerPage from "./views/EmployerPage";
import BusinessLanding from "./views/LandingPages/BusinessLanding";

// ✅ SEPARATE LOGINS
import AdminLogin from "./views/Admin/AdminLogin";
import BusinessLogin from "./views/Business/BusinessLogin";
import ResellerLogin from "./views/Reseller/ResellerLogin";

// Business
import BusinessDashboard from "./views/Business/BusinessDashboard";
import BusinessClients from "./views/Business/BusinessClients";
import BusinessLeads from "./views/Business/BusinessLeads";
import BusinessDrivers from "./views/Business/BusinessDrivers";
import BusinessProfile from "./views/Business/BusinessProfile";
import BusinessSettings from "./views/Business/BusinessSettings";
import BusinessTierSettings from "./views/Business/BusinessTierSettings";

// Reseller
import ResellerDashboard from "./views/Reseller/ResellerDashboard";
import ResellerClients from "./views/Reseller/ResellerClients";
import ResellerLeads from "./views/Reseller/ResellerLeads";
import ResellerProfile from "./views/Reseller/ResellerProfile";
import ResellerSettings from "./views/Reseller/ResellerSettings";
import ResellerAnalytics from "./views/Reseller/ResellerAnalytics";
import ResellerRevenue from "./views/Reseller/ResellerRevenue";

// Admin
import AdminDashboard from "./views/Admin/AdminDashboard";
import GlobalBusinessSwitcher from "./views/Admin/GlobalBusinessSwitcher";
import AdminBusinessImpersonate from "./views/Admin/AdminBusinessImpersonate";
import ContractorJobPage from "./views/Contractor/ContractorJobPage";
import RecruitmentJobs from "./views/Admin/RecruitmentJobs";
import JobsPage from "./views/JobsPage";
import SectorPage from "./views/SectorPage";
function PublicLayout({children}){
  return(
    <>
      <a className="skip-link" href="#public-content">Skip to content</a>
      <Header/>
      <div id="public-content" tabIndex={-1}>{children}</div>
      <Footer/>
    </>
  );
}

function AppRoutes(){
  const {pathname}=useLocation();
  useEffect(()=>{
    window.scrollTo(0,0);
    const titles={'/':'UK Recruitment','/jobs':'Current Vacancies','/services':'Our Services','/quote':'Register for Work','/employer':'Request Workers','/contact':'Contact','/privacy':'Privacy Policy','/terms':'Terms & Conditions'};
    document.title=`${titles[pathname] || 'AXU Workforce'} | AXU Workforce`;
  },[pathname]);
  return(
    <Routes>
<Route path="/admin/jobs" element={<RequireAuth role="admin"><DashboardLayout><RecruitmentJobs/></DashboardLayout></RequireAuth>}/>
<Route path="/jobs" element={<PublicLayout><JobsPage/></PublicLayout>}/>
<Route path="/jobs/:jobId" element={<PublicLayout><JobsPage/></PublicLayout>}/>
<Route path="/sectors/:sector" element={<PublicLayout><SectorPage/></PublicLayout>}/>
   <Route path="/contact" element={<PublicLayout><ContactPage/></PublicLayout>}
   />  <Route path="/contractor-job" element={<ContractorJobPage />} />
      <Route path="/" element={<PublicLayout><HomePage/></PublicLayout>}/>
      <Route path="/quote" element={<PublicLayout><QuotePage/></PublicLayout>}/>
      <Route path="/services" element={<PublicLayout><ServicesPage/></PublicLayout>}/>
      <Route path="/business-site" element={<PublicLayout><BusinessLanding/></PublicLayout>}/>
      <Route path="/employer" element={<PublicLayout><EmployerPage/></PublicLayout>}/>
      <Route path="/privacy" element={<PublicLayout><PrivacyPolicy/></PublicLayout>} />
      <Route path="/terms" element={<PublicLayout><TermsPage/></PublicLayout>} />
      <Route path="*" element={<PublicLayout><NotFoundPage/></PublicLayout>} />
      <Route path="/login" element={<Navigate to="/admin/login" replace/>}/>

      <Route path="/admin/login" element={<AdminLogin/>}/>
      <Route path="/business/login" element={<BusinessLogin/>}/>
      <Route path="/reseller/login" element={<ResellerLogin/>}/>

      <Route path="/business/dashboard" element={<RequireAuth role="business"><DashboardLayout><BusinessDashboard/></DashboardLayout></RequireAuth>}/>
      <Route path="/business/clients" element={<RequireAuth role="business"><DashboardLayout><BusinessClients/></DashboardLayout></RequireAuth>}/>
      <Route path="/business/leads" element={<RequireAuth role="business"><DashboardLayout><BusinessLeads/></DashboardLayout></RequireAuth>}/>
      <Route path="/business/drivers" element={<RequireAuth role="business"><DashboardLayout><BusinessDrivers/></DashboardLayout></RequireAuth>}/>
      <Route path="/business/profile" element={<RequireAuth role="business"><DashboardLayout><BusinessProfile/></DashboardLayout></RequireAuth>}/>
      <Route path="/business/settings" element={<RequireAuth role="business"><DashboardLayout><BusinessSettings/></DashboardLayout></RequireAuth>}/>
      <Route path="/business/tier" element={<RequireAuth role="business"><DashboardLayout><BusinessTierSettings/></DashboardLayout></RequireAuth>}/>

      <Route path="/reseller/dashboard" element={<RequireAuth role="reseller"><DashboardLayout><ResellerDashboard/></DashboardLayout></RequireAuth>}/>
      <Route path="/reseller/clients" element={<RequireAuth role="reseller"><DashboardLayout><ResellerClients/></DashboardLayout></RequireAuth>}/>
      <Route path="/reseller/leads" element={<RequireAuth role="reseller"><DashboardLayout><ResellerLeads/></DashboardLayout></RequireAuth>}/>
      <Route path="/reseller/profile" element={<RequireAuth role="reseller"><DashboardLayout><ResellerProfile/></DashboardLayout></RequireAuth>}/>
      <Route path="/reseller/settings" element={<RequireAuth role="reseller"><DashboardLayout><ResellerSettings/></DashboardLayout></RequireAuth>}/>
      <Route path="/reseller/analytics" element={<RequireAuth role="reseller"><DashboardLayout><ResellerAnalytics/></DashboardLayout></RequireAuth>}/>
      <Route path="/reseller/revenue" element={<RequireAuth role="reseller"><DashboardLayout><ResellerRevenue/></DashboardLayout></RequireAuth>}/>

      <Route path="/admin/dashboard" element={<RequireAuth role="admin"><DashboardLayout><AdminDashboard/></DashboardLayout></RequireAuth>}/>
      <Route path="/admin/switcher" element={<RequireAuth role="admin"><DashboardLayout><GlobalBusinessSwitcher/></DashboardLayout></RequireAuth>}/>
      <Route path="/admin/impersonate" element={<RequireAuth role="admin"><DashboardLayout><AdminBusinessImpersonate/></DashboardLayout></RequireAuth>}/>
    </Routes>
  );
}

export default function App(){
  return(
    <AuthProvider>
      <BrandingProvider>
        <Router>
          <AppRoutes/>
        </Router>
      </BrandingProvider>
    </AuthProvider>
  );
}